/* Lollystore 3.0 — Step 9B collection presentation helper.
   Mirrors the number of Enterprise-rendered active filter chips into the
   mobile toolbar. It does not submit, filter or sort.
*/
(() => {
  const updateFilterCount = () => {
    const badge = document.querySelector('[data-lolly-filter-count]');
    const activeFilters = document.querySelector('.facets__active-filters');
    if (!badge) return;

    // Enterprise itself renders exactly one .active-filter link per selected
    // list/boolean filter value, plus one for an active price range.
    // This avoids counting default form states or sort controls.
    const count = activeFilters
      ? activeFilters.querySelectorAll('.active-filters .active-filter').length
      : 0;

    badge.textContent = count;
    badge.hidden = count === 0;
  };

  const init = () => {
    updateFilterCount();
    document.addEventListener('on:facet-filters:updated', updateFilterCount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
